import React from 'react';
import styled from 'styled-components';

const Link = styled.a`
  position: absolute;
  left: 1rem;
  top: -100px;
  z-index: 10000;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  background: var(--primary-color);
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  text-decoration: none;

  &:focus {
    top: 1rem;
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;

const SkipLink = ({ targetId = 'main-content', label = 'Skip to main content' }) => (
  <Link href={`#${targetId}`}>{label}</Link>
);

export default SkipLink;
